module.exports = "/static/assets/9a0daedfe93c7ffa6116001ba50051e6.png";